import {React,useState,useEffect} from 'react';
import Header from '../../Layout/Header';
import NonCarouselBanner from '../../UI/Banner/NonCarouselBanner';
import hospitalImage from "../../assets/Images/hospitalPage/hospital-banner-image.webp";
import hospitalImageMob from "../../assets/Images/hospitalPage/hospital-banner-image-mobile.png";
import HospitalFacilities from './components/HospitalFacilities';
import BestHospital from '../../FeatureComponent/BestService/BestHospital';
import BennerWithContent from '../../UI/Banner/banner-with-content/BannerWithContent';
import BodyBannerImage from '../../assets/Images/hospitalPage/hospital-landing-page-body-banner.png';
import BodyBannerImageMob from '../../assets/Images/hospitalPage/hospital-landing-page-body-banner-mob.jpg';
import BannerContent from '../../StaticData/hospitalConsultations.json';
import Faq from '../../UI/Global-Component/Faq';
import YoutubeVideoBanner from '../../UI/Banner/youtube-video-banner/YoutubeVideoBanner';
import CommonModal from '../../UI/UIComponent/Modal/CommonModal'
import ConsultationBooking from '../../FeatureComponent/QuickBooking/consultationBooking'
import OtpModal from '../../UI/UIComponent/Modal/OtpModal';
import BestDoctor from '../../FeatureComponent/BestService/BestDoctor';
import MembershipCard from '../../UI/Global-Component/MembershipCard';
import Footer from '../../Layout/Footer';
import './hospital-page.scss';
import faqData from '../../StaticData/hospitalPageFaq.json';



export default function HospitalLandingPage() {
   const [patientPayload, setpatientPayload] = useState({})
    const [encodedData, setEncodeddata] = useState()
    const handleBookAppointment = () =>{
      let modalRef = document.getElementById('consultation-modal');
    modalRef.classList.add('show');
    }
    const handleCallback = (childData) => {
    setpatientPayload({ ...childData })
    setEncodeddata(childData.encodedData)
  }
  return (
     <>
      <CommonModal></CommonModal>
      <ConsultationBooking parentCallback={handleCallback}></ConsultationBooking>
      <OtpModal patientInfoPayload = {patientPayload} patientEncodedData = {encodedData}></OtpModal>
      <Header pageId={'3'}></Header>
      <section className='hospital-landing-page'>
        <NonCarouselBanner
          mobImageSrc={hospitalImageMob}
          ImageSrc={hospitalImage}
          imageAlt="RHS Hospital Addmission"
          buttonOnclick={handleBookAppointment}
          heading = "Rever Health Solution"
          Subheading= "Consult Our Trusted Surgeons, Book an Appointment"
          footNote = "The best of modern healthcare to ensure you stay healthy, always."
        ></NonCarouselBanner>
        
        <HospitalFacilities handleConsultNow={handleBookAppointment}></HospitalFacilities>
        <BennerWithContent imagepath={BodyBannerImage} mobimagepath={BodyBannerImageMob} bannerContent={BannerContent.BannerContent.content}></BennerWithContent>
        <BestHospital isBestEnabled={true}></BestHospital>
        
        <YoutubeVideoBanner videoId="WdvG_x3xDBg"></YoutubeVideoBanner>
        <BestDoctor></BestDoctor>
        <MembershipCard></MembershipCard>
        <Faq faqData={faqData.faqData}></Faq>
        <Footer></Footer>
      </section>
    </>
  )
}
